import React, { useRef, useState, useEffect } from "react";
import "../AcademicCalender/AcademicCalender.css";
import axios from "../../utils/axiosConfig";
import jsPDF from "jspdf";
import schoolLogo from "../../assets/images/npw-logo.png";

const AcademicCalender = () => {

const [eventsData, setEventsData] = useState([]);
const [activeYear, setActiveYear] = useState(null);
const [activeMonth, setActiveMonth] = useState("All");

const currentMonthRef = useRef(null);

/* FETCH EVENTS FROM MYSQL */

useEffect(() => {

const fetchEvents = async () => {

  try {
    const res = await axios.get("/api/calendar");
    const dbEvents = res.data;
    const grouped = {};
    dbEvents.forEach(ev => {

      const yearKey = ev.lstyear;

      if (!grouped[yearKey]) {
        grouped[yearKey] = {
          year: yearKey,
          events: []
        };
      }

      grouped[yearKey].events.push({
        lstno: ev.lstno,
        months: ev.months,
        lstyear: ev.lstyear,
        title: ev.title,
        day: ev.day,
        date: ev.date_text,
        type: ev.type
      });
    });

    const structured = Object.values(grouped);
    setEventsData(structured);

    if (structured.length > 0) {
      const latestYear = structured.sort((a,b)=>b.year-a.year)[0].year;
      setActiveYear(latestYear);
    }
  } catch (err) {
    console.error("Calendar fetch error:", err);
  }
};

fetchEvents();
}, []);

const sortedYears = [...eventsData].sort((a, b) => b.year - a.year);

const selectedYearData =
sortedYears.find(item => item.year === activeYear) || { events: [] };

const sortedEvents =
selectedYearData && selectedYearData.events ? selectedYearData.events : [];

const monthOrder = [
"April","May","June","July","August","September",
"October","November","December",
"January","February","March"
];

const months = ["All", ...monthOrder];

/* FILTER EVENTS */

const filteredEvents = sortedEvents.filter((event) => {

if (activeMonth === "All") {
  return event.lstyear === activeYear;
}

return (
  event.lstyear === activeYear &&
  event.months === activeMonth
);
});

/* DATE SUPERSCRIPT */
const formatDate = (date) => {
const regex = /(\d+)(st|nd|rd|th)/g;

return date.replace(regex, (match, num, suffix) => {
  return `${num}<sup>${suffix}</sup>`;
});
};

const today = new Date();
const currentMonth = today.toLocaleString("default", { month: "long" });
const currentYear = today.getFullYear();
const todayDay = today.getDate();
const todayMonth = today.toLocaleString("default", { month: "long" });
const todayYear = today.getFullYear();

useEffect(() => {
if (currentMonthRef.current) {

  currentMonthRef.current.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
}, []);


   /* PROFESSIONAL SCHOOL PDF */
   const downloadPDF = async () => {
   const doc = new jsPDF("p", "mm", "a4");
   const pageWidth = doc.internal.pageSize.getWidth();
   let y = 20;
   try {

    /* LOAD LOGO */
    const response = await fetch(schoolLogo);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.onloadend = () => {
    const logoBase64 = reader.result;

      /* HEADER */
      doc.addImage(logoBase64, "PNG", 15, 10, 20, 20);

      doc.setFontSize(18);
      doc.setFont(undefined, "bold");
      doc.text("NORTH POINT CHILDREN'S ACADEMY", pageWidth / 2, 18, { align: "center" });

      doc.setFontSize(10);
      doc.setFont(undefined, "normal");
      doc.text("50, Tapkeshwar Road, Garhi Cantt, Dehradun, Uttarakhand - 248003", pageWidth / 2, 24, { align: "center" });

      doc.text("Ph: +91-0135-3598009, +91-9837923036, +91-8273065299  |  www.northpointdoon.in", pageWidth / 2, 29, { align: "center" });

      /* HEADER LINE */

      doc.setLineWidth(0.5);
      doc.line(14, 34, pageWidth - 14, 34);

      /* TITLE */

      doc.setFontSize(14);
      doc.setFont(undefined, "bold");
      doc.text(`ACADEMIC CALENDAR ${activeYear}-${activeYear + 1}`, pageWidth / 2, 42, { align: "center" });

      y = 50;

      let currentMonthName = "";

      sortedEvents.forEach(ev => {

        /* NEW PAGE IF SPACE LOW */

        if (y > 270) {

          addFooter(doc);

          doc.addPage();

          y = 20;

        }

        /* MONTH HEADING */

        if (currentMonthName !== ev.months) {

          currentMonthName = ev.months;

          doc.setFontSize(13);
          doc.setFont(undefined, "bold");

          doc.text(currentMonthName.toUpperCase(), 15, y);

          y += 6;

          doc.setFont(undefined, "normal");

        }

        /* EVENT TEXT */

        const line = `• ${ev.day} ${ev.date} – ${ev.title}`;

        const wrappedText = doc.splitTextToSize(line, 170);

        /* EVENT TYPE COLORS */

        if (ev.type === "holiday") doc.setTextColor(200, 0, 0);
        else if (ev.type === "exam") doc.setTextColor(0, 70, 160);
        else if (ev.type === "activity") doc.setTextColor(0, 120, 0);
        else if (ev.type === "meeting") doc.setTextColor(200, 120, 0);
        else doc.setTextColor(0, 0, 0);

        doc.setFontSize(11);

        doc.text(wrappedText, 18, y);

        doc.setTextColor(0, 0, 0);

        y += wrappedText.length * 6;

      });

      /* FINAL FOOTER */

      addFooter(doc);

      doc.save(`Academic_Calendar_${activeYear}.pdf`);

    };

    reader.readAsDataURL(blob);

  } catch (err) {

    console.error("Logo load error:", err);

  }

};


/* FOOTER FUNCTION */

const addFooter = (doc) => {

  const pageCount = doc.internal.getNumberOfPages();

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  for (let i = 1; i <= pageCount; i++) {

    doc.setPage(i);

    doc.setLineWidth(0.3);

    doc.line(14, pageHeight - 20, pageWidth - 14, pageHeight - 20);

    doc.setFontSize(9);

    doc.text(
      "North Point Children's Academy  |  www.northpointdoon.in",
      pageWidth / 2,
      pageHeight - 14,
      { align: "center" }
    );

    doc.text(
      `Page ${i} of ${pageCount}`,
      pageWidth - 20,
      pageHeight - 8
    );

  }

};

return ( <section className="academic-section container-fluid">

  <div className="container">

    {/* HEADER */}
    <div className="academic-header text-center">
      <h2>ACADEMIC CALENDAR</h2>
      <p>Explore events, exams & activities in a premium timeline view</p>
    </div>

    {/* PDF BUTTON */}

    <div style={{textAlign:"right", marginBottom:"15px"}}>
      <button
        className="year-btn"
        onClick={downloadPDF}
      >
        Download Academic Calendar PDF
      </button>
    </div>

    {/* YEAR SELECTOR */}

    <div className="year-tabs">
      {sortedYears.map((item) => (
        <button
          key={item.year}
          className={`year-btn ${activeYear === item.year ? "active" : ""}`}
          onClick={() => {
            setActiveYear(item.year);
            setActiveMonth("All");
          }}
        >
          {item.year}
        </button>
      ))}
    </div>

    {/* MONTH SELECTOR */}

    <div className="year-tabs">
      {months.map((month) => (
        <button
          key={month}
          className={`year-btn ${activeMonth === month ? "active" : ""}`}
          onClick={() => setActiveMonth(month)}
        >
          {month}
        </button>
      ))}
    </div>

    {/* TIMELINE */}

    <div className="timeline">

      {(() => {

        let lastMonth = "";
        let lastYear = "";

        return filteredEvents.map((item, index) => {

          const eventDay = parseInt(item.date);

          const isTodayEvent =
            eventDay === todayDay &&
            item.months === todayMonth &&
            item.lstyear === todayYear;

          const eventDateObj =
            new Date(`${item.months} ${eventDay}, ${item.lstyear}`);

          const diffTime = eventDateObj - today;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);

          const isUpcomingEvent = diffDays > 0 && diffDays <= 30;

          const showHeading =
            item.months !== lastMonth || item.lstyear !== lastYear;

          lastMonth = item.months;
          lastYear = item.lstyear;

          return (
            <React.Fragment key={index}>

              {showHeading && (
                <div
                  ref={
                    item.months === currentMonth && item.lstyear === currentYear
                      ? currentMonthRef
                      : null
                  }
                  className={`timeline-month ${
                    item.months === currentMonth && item.lstyear === currentYear
                      ? "active-month"
                      : ""
                  }`}
                >
                  {item.months.toUpperCase()} {item.lstyear}
                </div>
              )}

              <div className={`timeline-item ${item.type}`}>

                <div className="timeline-dot"></div>

                <div className={`timeline-card ${item.type} ${isTodayEvent ? "today-event" : ""}`}>

                  <div
                    className="timeline-date"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span>{item.day}</span>

                    <span style={{ margin: "0 5px" }}>-</span>

                    <h6
                      style={{ margin: 0 }}
                      dangerouslySetInnerHTML={{
                        __html: formatDate(item.date)
                      }}
                    ></h6>
                  </div>

                  <div className="timeline-content">
                    <h5>
                      {item.title}
                      {isUpcomingEvent && (
                        <span className="event-badge">NEW</span>
                      )}
                    </h5>
                  </div>

                </div>

              </div>

            </React.Fragment>
          );

        });

      })()}

    </div>

  </div>

</section>
);
};

export default AcademicCalender;
